module.exports = __webpack_public_path__ + "static/media/tequila.b7b9d1e5.svg";